import { STATUS_LABEL } from "@/lib/format";

export const PageHeader = ({ title, description, children }) => (
  <div className="flex flex-col gap-3 border-b border-zap-line bg-white px-5 py-4 sm:flex-row sm:items-end sm:justify-between md:px-8">
    <div>
      <h1 className="font-display text-2xl font-semibold text-zap-ink">{title}</h1>
      {description && <p className="mt-0.5 text-[15px] text-muted-foreground">{description}</p>}
    </div>
    {children && <div className="flex flex-wrap items-center gap-2">{children}</div>}
  </div>
);

export const StatusPill = ({ status }) => {
  const map = {
    recebido: "bg-zap-goldsoft text-[#7A5A14]",
    visualizado: "bg-sky-50 text-sky-800",
    resposta_preparada: "bg-violet-50 text-violet-800",
    pendente_confirmacao: "bg-orange-50 text-orange-800",
    respondido: "bg-emerald-50 text-emerald-800",
    pendente: "bg-zap-goldsoft text-[#7A5A14]",
    conferido: "bg-emerald-50 text-emerald-800",
    divergente: "bg-red-50 text-red-800",
  };
  const label = { ...STATUS_LABEL, pendente: "A conferir", conferido: "Conferido", divergente: "Divergente" };
  return <span data-testid="status-pill" className={`inline-flex items-center whitespace-nowrap rounded px-2 py-0.5 text-xs font-semibold ${map[status] || "bg-muted"}`}>{label[status] || status}</span>;
};

export const Empty = ({ children, testId }) => (
  <div data-testid={testId} className="px-6 py-16 text-center text-[15px] text-muted-foreground">{children}</div>
);
